import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";

interface IAddressPayload {
    addressLine1: string;
    addressLine2?: string;
    addressLine3?: string;
    county: string;
    eircode?: string;
    town: string;
}

interface IPermissionPayload {
    enabled: boolean;
    name: string;
    permission: string;
}

interface IPermissionGroupPayload {
    name: string;
    permissionGroup: string;
    permissions: IPermissionPayload[];
}

interface IContactPermissionPayload {
    permissionGroups: IPermissionGroupPayload[];
}

export interface ICustomerDetailsPayload {
    firstName: string;
    lastName: string;
    birthDate: string;
    email: string;
    primaryPhoneNumber: string | null;
    permissions: IContactPermissionPayload;
    billingAddress: IAddressPayload;
    deliveryAddress: IAddressPayload;
    recaptchaResponse: string | undefined;
}

export const getStateToPayload = (
    customerDetails: ICustomerDetails,
    recaptchaValue: string | undefined
): ICustomerDetailsPayload => ({
    billingAddress: {
        addressLine1: customerDetails.billingAddress.addressLine1,
        addressLine2: customerDetails.billingAddress.addressLine2,
        addressLine3: customerDetails.billingAddress.addressLine3,
        county: customerDetails.billingAddress.county,
        eircode: customerDetails.billingAddress.eircode,
        town: customerDetails.billingAddress.town,
    },
    permissions: {
        permissionGroups: customerDetails.contactPermission.permissionGroups.map((permissionGroup) => ({
            name: permissionGroup.name,
            permissionGroup: permissionGroup.permissionGroup,
            permissions: permissionGroup.permissions.map((permission) => ({
                enabled: permission.enabled,
                name: permission.name,
                permission: permission.permission,
            })),
        })),
    },
    deliveryAddress: {
        addressLine1: customerDetails.deliveryAddress.addressLine1,
        addressLine2: customerDetails.deliveryAddress.addressLine2,
        addressLine3: customerDetails.deliveryAddress.addressLine3,
        county: customerDetails.deliveryAddress.county,
        eircode: customerDetails.deliveryAddress.eircode,
        town: customerDetails.deliveryAddress.town,
    },
    firstName: customerDetails.firstName,
    lastName: customerDetails.lastName,
    birthDate: customerDetails.birthDate,
    email: customerDetails.email,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    primaryPhoneNumber: customerDetails.mobileNumber || null,
    recaptchaResponse: recaptchaValue,
});
